import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricWebviewGetCurrentPagesOptions = {
  /**
   * 是否计算webview栈中穿插native页面
   * @default true
   */
  includeNativePage?: boolean;
};

export type FabricWebviewGetCurrentPagesApi = (
  options?: FabricWebviewGetCurrentPagesOptions
) => number;

/**
 * 获取当前webview页面栈。数组中第一个元素为首页，最后一个元素为当前页面, 如果中间存在原生的页面, 则忽略掉. 不计算
 * @returns number
 */
export const getCurrentPages: FabricWebviewGetCurrentPagesApi = (
  options: FabricWebviewGetCurrentPagesOptions = { includeNativePage: true }
) => {
  const result = core.call<
    'fabric_webview.getCurrentPages',
    FabricWebviewGetCurrentPagesOptions,
    number
  >('fabric_webview.getCurrentPages', options);
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
